export interface ErrorItemReference {
    itemId?: string;
    itemNumberToday?: number;
}

export interface ResolvedErrorField {
    item?: ErrorItemReference;
    formPath: string;
}

export interface ErrorFieldContext {
    itemSegment: string;
    firstNumber: 0 | 1;
    submittedItems?: { id?: string }[];
    currentItems: { id?: string }[];
}

/**
 * Turns the path of a customs error into the item it names and the field inside it. Customs names an
 * item by its position in the submission, so the position is read against the submitted items - items
 * deleted since have moved the ones after them up in the declaration today.
 */
const resolveErrorField = (
    path: string,
    { itemSegment, firstNumber, submittedItems, currentItems }: ErrorFieldContext
): ResolvedErrorField => {
    const segments = path.split('.');
    const itemSegmentPosition = segments.indexOf(itemSegment);
    const numberSegment = itemSegmentPosition === -1 ? undefined : segments[itemSegmentPosition + 1];
    const itemNumber = numberSegment ? Number(numberSegment) : NaN;

    if (isNaN(itemNumber)) return { formPath: path };

    const position = itemNumber - firstNumber;
    const itemId = (submittedItems ?? currentItems)[position]?.id;
    const positionToday = itemId ? currentItems.findIndex(({ id }) => id === itemId) : -1;

    return {
        item: { itemId, itemNumberToday: positionToday === -1 ? undefined : positionToday + 1 },
        formPath: segments.slice(itemSegmentPosition + 2).join('.'),
    };
};

export default resolveErrorField;
